export default __webpack_public_path__ + "static/media/finger.464e9211.svg";